import { Component, OnInit } from '@angular/core';
import { Subscriber } from 'rxjs';
import { DbService } from 'src/app/core/services/db.service';

@Component({
  selector: 'app-show-terms',
  templateUrl: './show-terms.component.html',
  styleUrls: ['./show-terms.component.scss'],
})
export class ShowTermsComponent implements OnInit {
  service: string;
  sub = new Subscriber();

  constructor(private db: DbService) {}

  ngOnInit() {
    const service = this.db.doc$('admin/admin').subscribe(({ service }) => {
      this.service = service;
    });
    this.sub.add(service);
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }
}
